// This component provides map and marker style customization options for the map.
// Users can select different map styles, marker colors, and marker sizes using the dropdown controls.
import Dropdown from "react-bootstrap/Dropdown";
import Form from "react-bootstrap/Form";

const StyleSelections = ({ setStyles, styles }) => {
  const styleOptions = {
    mapStyle: [
      { value: "mapbox://styles/mapbox/streets-v12", label: "Streets" },
      { value: "mapbox://styles/mapbox/satellite-v9", label: "Satellite" },
      { value: "mapbox://styles/mapbox/light-v10", label: "Light" },
      { value: "mapbox://styles/mapbox/dark-v10", label: "Dark" },
      { value: "mapbox://styles/mapbox/outdoors-v12", label: "Outdoors" },
      {
        value: "mapbox://styles/mapbox/satellite-streets-v12",
        label: "Satellite Streets",
      },
      {
        value: "mapbox://styles/mapbox/navigation-day-v1",
        label: "Navigation Day",
      },
      {
        value: "mapbox://styles/mapbox/navigation-night-v1",
        label: "Navigation Night",
      },
    ],
    markerShape: [
      { value: "bi bi-geo-alt-fill", label: "Geo-Marker" },
      { value: "fas fa-map-pin", label: "Pin" },
      { value: "bi bi-circle-fill", label: "Circle" },
      { value: "bi bi-square-fill", label: "Square" },
      { value: "bi bi-star-fill", label: "Star" },
      { value: "bi bi-asterisk", label: "Asterisk" },
    ],
    markerColourNormal: [
      { value: "#000000", label: "Black" },
      { value: "#FFFFFF", label: "White" },
      { value: "#1CA3F0", label: "Spectra Blue" },
      { value: "#F08021", label: "Spectra Orange" },
      { value: "#333333", label: "Dark Gray" },
      { value: "#E5E5E5", label: "Light Gray" },
      { value: "#004AAD", label: "Royal Blue" },
      { value: "#FF5733", label: "Red" },
      { value: "#28A745", label: "Green" },
      { value: "#FFC107", label: "Yellow" },
    ],
    markerColourActive: [
      { value: "#000000", label: "Black" },
      { value: "#FFFFFF", label: "White" },
      { value: "#1CA3F0", label: "Spectra Blue" },
      { value: "#F08021", label: "Spectra Orange" },
      { value: "#333333", label: "Dark Gray" },
      { value: "#E5E5E5", label: "Light Gray" },
      { value: "#004AAD", label: "Royal Blue" },
      { value: "#FF5733", label: "Red" },
      { value: "#28A745", label: "Green" },
      { value: "#FFC107", label: "Yellow" },
    ],
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setStyles((prevStyles) => ({
      ...prevStyles,
      [name]: value,
    }));
  };

  return (
    <Dropdown>
      <Dropdown.Toggle variant='dark' id='dropdown-basic-button'>
        Styles
      </Dropdown.Toggle>

      <Dropdown.Menu
        className='p-3'
        style={{ backgroundColor: "rgba(236, 236, 236, 0.75)" }}
      >
        <Form className='d-flex flex-column gap-3'>
          <Form.Group className='mb-1'>
            <Form.Label className='fw-semibold'>Map Style:</Form.Label>
            <Form.Select
              name='mapStyle'
              value={styles.mapStyle}
              onChange={(e) => {
                handleChange(e);
              }}
            >
              {styleOptions.mapStyle.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group className='mb-1'>
            <Form.Label className='fw-semibold'>Marker Shape:</Form.Label>
            <Form.Select
              name='markerShape'
              value={styles.markerShape}
              onChange={(e) => {
                handleChange(e);
              }}
            >
              {styleOptions.markerShape.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group className='mb-1'>
            <Form.Label className='fw-semibold'>
              Marker Colour - Normal:
            </Form.Label>
            <Form.Select
              name='markerColourNormal'
              value={styles.markerColourNormal}
              onChange={(e) => {
                handleChange(e);
              }}
            >
              {styleOptions.markerColourNormal.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group className='mb-1'>
            <Form.Label className='fw-semibold'>
              Marker Colour - Active:
            </Form.Label>
            <Form.Select
              name='markerColourActive'
              value={styles.markerColourActive}
              onChange={(e) => {
                handleChange(e);
              }}
            >
              {styleOptions.markerColourActive.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          <div className='d-flex flex-column mb-1'>
            <Form.Label className='fw-semibold'>Marker Size:</Form.Label>
            <Form.Range
              name='markerSize'
              id='markerSizeRange'
              onChange={handleChange}
              value={styles.markerSize}
              max={75}
              min={5}
              className='p-1 border border-1'
              style={{ backgroundColor: "white", borderRadius: "5px" }}
            />
            <output className='mt-2' id='rangeValue' aria-hidden='true'>
              Size: {styles.markerSize || "Default Size"}px
            </output>
          </div>
        </Form>
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default StyleSelections;
